(function () {
  var STOREFRONT_URL = 'https://' + window.__shopDomain + '/api/2025-01/graphql.json';
  var TOKEN = window.__storefrontToken || '';

  function formatDate(d) {
    if (!d || d.length !== 8) return d || '';
    return d.slice(6, 8) + '/' + d.slice(4, 6) + '/' + d.slice(0, 4);
  }

  function getStatoClass(s) {
    if (s === 'In lavorazione') return 'sr-badge--lavorazione';
    if (s === 'Completata') return 'sr-badge--completata';
    if (s === 'Annullata') return 'sr-badge--annullata';
    return 'sr-badge--attesa';
  }

  function getMessaggio(s) {
    if (s === 'In lavorazione') return 'Il tuo pacco è arrivato e i nostri esperti stanno analizzando le carte.\nTi aggiorneremo a breve con la valutazione definitiva.';
    if (s === 'Completata') return 'La valutazione del tuo lotto è completata.';
    if (s === 'Annullata') return 'Purtroppo non siamo in grado di procedere con il ritiro del tuo lotto.\nContattaci per maggiori informazioni.';
    return 'La tua richiesta è stata registrata con successo.\nTi risponderemo entro 24–72 ore lavorative con la nostra valutazione.';
  }

  // ✅ validazione formato: RIT-YYYYMMDD-0001
  function validaNumeroRichiesta(n) {
    return /^RIT-\d{8}-\d{4}$/i.test(n);
  }

  async function cerca(numero, email) {
    var handle = numero.toLowerCase();

    var query = `
    {
      metaobject(handle: {type: "sidekick_ritiro_singole", handle: "${handle}"}) {
        handle
        nr: field(key: "numero_richiesta") { value }
        dr: field(key: "data_richiesta") { value }
        em: field(key: "email_cliente") { value }
        gi: field(key: "gioco") { value }
        tl: field(key: "tipo_lotto") { value }
        st: field(key: "stato") { value }
        vf: field(key: "valutazione_finale") { value }
      }
    }`;

    var r = await fetch(STOREFRONT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': TOKEN
      },
      body: JSON.stringify({ query: query })
    });

    if (!r.ok) throw new Error('Errore di rete (' + r.status + '). Riprova più tardi.');
    var j = await r.json();
    if (j.errors && j.errors.length) throw new Error(j.errors[0].message);

    var o = j.data && j.data.metaobject;
    if (!o) throw new Error('Nessuna richiesta trovata con questo numero.');

    var em = (o.em && o.em.value) || '';
    if (em.toLowerCase().trim() !== email.toLowerCase().trim()) {
      throw new Error('Email non corrispondente. Verifica i dati inseriti.');
    }

    return {
      numero: (o.nr && o.nr.value) || numero,
      data:   (o.dr && o.dr.value) || '',
      gioco:  (o.gi && o.gi.value) || '—',
      lotto:  (o.tl && o.tl.value) || '—',
      stato:  (o.st && o.st.value) || 'In attesa',
      val:    (o.vf && o.vf.value) || ''
    };
  }

  function mostraRisultato(d) {
    document.getElementById('sr-error').style.display = 'none';
    document.getElementById('sr-result-numero').textContent = d.numero;
    var b = document.getElementById('sr-result-badge');
    b.textContent = d.stato;
    b.className = 'sr-badge ' + getStatoClass(d.stato);
    document.getElementById('sr-result-data').textContent = formatDate(d.data);
    document.getElementById('sr-result-gioco').textContent = d.gioco;
    document.getElementById('sr-result-lotto').textContent = d.lotto;
    document.getElementById('sr-result-message').textContent = getMessaggio(d.stato);
    var c = document.getElementById('sr-result-credito');
    if (d.stato === 'Completata' && d.val) {
      document.getElementById('sr-result-credito-value').textContent = d.val;
      c.style.display = 'flex';
    } else {
      c.style.display = 'none';
    }
    document.getElementById('sr-result').style.display = 'block';
  }

  function mostraErrore(msg) {
    document.getElementById('sr-result').style.display = 'none';
    document.getElementById('sr-error-msg').textContent = msg;
    document.getElementById('sr-error').style.display = 'block';
  }

  // autocompilazione da URL + invio automatico se numero+email presenti
  function autoFillFromURL() {
    var params = new URLSearchParams(window.location.search);
    var numero = params.get('numero');
    var email = params.get('email');

    if (numero) document.getElementById('sr-numero').value = numero.toUpperCase();
    if (email) document.getElementById('sr-email').value = email;

    if (numero && email) {
      setTimeout(function () {
        document.getElementById('sr-submit').click();
      }, 300);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('sr-form');
    if (!form) return;

    autoFillFromURL();

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      var numero = document.getElementById('sr-numero').value.trim().toUpperCase();
      var email  = document.getElementById('sr-email').value.trim();

      if (!validaNumeroRichiesta(numero)) {
        mostraErrore('Formato numero richiesta non valido. Usa: RIT-YYYYMMDD-0001');
        return;
      }

      if (!numero || !email) return;

      var btn = document.getElementById('sr-submit');
      btn.disabled = true;
      btn.querySelector('.sr-btn-text').style.display = 'none';
      btn.querySelector('.sr-btn-loading').style.display = 'inline';
      try {
        mostraRisultato(await cerca(numero, email));
      } catch (err) {
        mostraErrore(err.message || 'Errore imprevisto. Riprova più tardi.');
      } finally {
        btn.disabled = false;
        btn.querySelector('.sr-btn-text').style.display = 'inline';
        btn.querySelector('.sr-btn-loading').style.display = 'none';
      }
    });
  });
})();
